import React from "react";
import classNames from "classnames";

import style from "./Loader.module.scss";
import loaderIcon from "../../assets/images/loader.svg";

interface LoaderProps {
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ className }) => {
  return <img className={classNames(style.loader, className)} src={loaderIcon} />;
};

export default Loader;
